import { IExpense } from '../../../shared/interfaces/expenses/IExpense';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { EXPENSE_URL } from '../../../utils/api/endpoints';

export const AdminExpenseService = {
  get: (pagination: IPagination): Promise<IBaseModel<IExpense[]>> =>
    requests.get(EXPENSE_URL, pagination),
  getSingle: (id: number): Promise<IExpense> =>
    requests.get(`${EXPENSE_URL}/${id}`),
  create: (params: IExpense): Promise<IExpense> =>
    requests.post(EXPENSE_URL, params),
  update: (params: IExpense, id: number): Promise<IExpense> =>
    requests.put(`${EXPENSE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${EXPENSE_URL}/${id}`),
};
